import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "";
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

// Verifica che le variabili d'ambiente siano definite
if (!supabaseUrl || !supabaseKey) {
  console.warn(
    "Attenzione: Le variabili d'ambiente SUPABASE non sono configurate correttamente."
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Tipi per i dati
export interface Menu {
  id: number;
  week_number: number;
  day_of_week: number;
  meal: string;
}

export interface Snack {
  id: number;
  day_of_week: number;
  snack: string;
}

export interface Settings {
  id: number;
  rotation_start_date: string;
}
